// extracted by mini-css-extract-plugin
export default {"divider":"InitialTemplateCard_divider__2tH91"};